import { estimateConstants } from '../constants/actionTypes'
import * as opportunityService from '../services/consultant/opportunityService'
import { alertError } from './alertActions'

export const fetchEstimatesRequest = () => ({
  type: estimateConstants.FETCH_ESTIMATES_REQUEST,
})

export const fetchEstimatesSuccess = (data) => ({
  type: estimateConstants.FETCH_ESTIMATES_SUCCESS,
  estimates: data.quotes,
  tradeIn: data.tradeIn,
})

export const fetchEstimatesError = (errorMessage) => ({
  type: estimateConstants.FETCH_ESTIMATES_ERROR,
  errorMessage,
})

export function fetchEstimates(opportunityId, headers, httpVerb) {
  return (dispatch) => {
    dispatch(fetchEstimatesRequest())
    return opportunityService
      .fetchEstimates(opportunityId, headers, httpVerb)
      .then(
        (data) => {
          dispatch(fetchEstimatesSuccess(data))
        },
        (error) => {
          //const err = `could not retrieve user from opportunityId # ${opportunityId}`
          //dispatch(fetchUserError(error))
          dispatch(alertError(error))
        }
      )
  }
}
